/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePaymentMethodDto } from '../models/CreatePaymentMethodDto';
import type { UpdatePaymentMethodDto } from '../models/UpdatePaymentMethodDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PaymentMethodsService {
  /**
   * Create a new payment method
   * @param requestBody
   * @returns any Payment method created successfully
   * @throws ApiError
   */
  public static paymentMethodsControllerCreate(
    requestBody: CreatePaymentMethodDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/payment-methods',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        409: `Payment method already exists`,
      },
    });
  }
  /**
   * Get all payment methods
   * @param page Page number
   * @param limit Items per page
   * @param search Search by name, code, or description
   * @returns any Returns all payment methods
   * @throws ApiError
   */
  public static paymentMethodsControllerFindAll(
    page?: number,
    limit?: number,
    search?: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payment-methods',
      query: {
        page: page,
        limit: limit,
        search: search,
      },
      errors: {
        401: `Unauthorized`,
      },
    });
  }
  /**
   * Get all active payment methods
   * @returns any Returns active payment methods
   * @throws ApiError
   */
  public static paymentMethodsControllerFindActive(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payment-methods/active',
    });
  }
  /**
   * Get a payment method by ID
   * @param id
   * @returns any Returns the payment method
   * @throws ApiError
   */
  public static paymentMethodsControllerFindOne(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payment-methods/{id}',
      path: {
        id: id,
      },
      errors: {
        404: `Payment method not found`,
      },
    });
  }
  /**
   * Update a payment method
   * @param id
   * @param requestBody
   * @returns any Payment method updated successfully
   * @throws ApiError
   */
  public static paymentMethodsControllerUpdate(
    id: string,
    requestBody: UpdatePaymentMethodDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/payment-methods/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Payment method not found`,
        409: `Payment method already exists`,
      },
    });
  }
  /**
   * Delete a payment method
   * @param id
   * @returns any Payment method deleted successfully
   * @throws ApiError
   */
  public static paymentMethodsControllerRemove(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/payment-methods/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Payment method is in use`,
        404: `Payment method not found`,
      },
    });
  }
}
